import { ButtonHTMLAttributes, forwardRef, ReactNode } from "react";
import s from "./Button.module.scss";

export type ButtonProps = {
  variant?: "primary" | "secondary" | "ghost" | "danger";
  icon?: ReactNode;
  loading?: boolean;
  fullWidth?: boolean;
} & ButtonHTMLAttributes<HTMLButtonElement>;

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant = "secondary", icon, loading, fullWidth, type = "button", disabled, className, children, ...rest }, ref) => (
    <button
      ref={ref}
      type={type}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      className={[s.btn, s[variant], fullWidth ? s.full : "", className ?? ""].join(" ").trim()}
      {...rest}
    >
      {loading ? <span className={s.spinner} aria-hidden /> : icon && <span className={s.icon} aria-hidden>{icon}</span>}
      {children}
    </button>
  )
);
Button.displayName = "Button";
